/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TotalEnergyResponse } from '../../models/total-energy-response';

export interface GetTotalEnergyReading$Params {
  location_id: string;

/**
 * ISO-8601 timestamp with offset
 */
  at?: string;
}

export function getTotalEnergyReading(http: HttpClient, rootUrl: string, params: GetTotalEnergyReading$Params, context?: HttpContext): Observable<StrictHttpResponse<TotalEnergyResponse>> {
  const rb = new RequestBuilder(rootUrl, getTotalEnergyReading.PATH, 'get');
  if (params) {
    rb.path('location_id', params.location_id, {});
    rb.query('at', params.at, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TotalEnergyResponse>;
    })
  );
}

getTotalEnergyReading.PATH = '/locations/{location_id}/energy-readings/total';
